<template>
    <div :data-element="'cart_block_' + blockIndex"
         class="cart__wrap">
        <div class="cart__row">
            <div v-if="blockLogo !== ''"
                 class="cart__grow">
                <svg v-if="blockLogo !== ''" class="svg-icon"
                     width="151"
                     :class="'icon--' + blockLogo"
                     :viewBox="logoViewBox[blockLogo]">
                    <use :xlink:href="'#icon-' + blockLogo"></use>
                </svg>
                <br>
                <template v-for="(discount, itemDiscount) in cartDiscount" :key="blockId + itemDiscount">
                    <div v-if="cartTotalDiscountFull() > 0"
                         class="cart__mt--sm cart__note"
                         :class="{
               'cart__note--blue': discount.ASTERISK === '*',
               'cart__note--violet': discount.ASTERISK === '**'
             }">
                        {{ discount.DESCRIPTION }}
                    </div>
                </template>
            </div>

            <div v-if="cartTotalDiscountFull() > 0"
                 class="cart__right">
                <div class="cart__price">
                    <span class="cart__val cart__val--big cart__val--red">{{
                            formatPrice(blockTotalPrice - cartTotalDiscountFull())
                        }}</span>
                    <span class="cart__units cart__units--red">руб.</span>
                </div>
                <div class="cart__price cart__price--strike">
                    <span class="cart__val">{{ formatPrice(blockTotalPrice) }}</span>
                    <span class="cart__units"> руб.</span>
                </div>
            </div>
            <div v-else class="cart__right">
                <div class="cart__price">
            <span :data-element="'cart_block_total_price_' + blockIndex"
                  class="cart__val cart__val--big">
              {{ formatPrice(blockTotalPrice) }}
            </span>
                    <span class="cart__units"> руб.</span>
                </div>
            </div>
        </div>

        <div v-if="blockId === 'withoutParent' && !isMDGBlock"
             class="cart__row cart__version">
            <div class="cart__grow">Для работы номеров необходима Виртуальная АТС</div>
            <div class="cart__right">
                <a
                    :data-element="'cart_select_vpbx_' + blockIndex" href="/shop/tariffs/vpbx/"
                    class="button button--sm">
                  Выбрать версию
                </a>
            </div>
        </div>

        <div v-if="blockId !== 'withoutParent' && needAddTariffMvno"
             class="cart__row cart__version">
          <div class="cart__grow">Для работы номеров МангоМобайл необходим тариф</div>
          <div class="cart__right">
            <a
                :data-element="'cart_select_nvmo_' + blockIndex" href="/shop/tariffs/mvno/"
                class="button button--sm"
            >
              Выбрать тариф
            </a>
          </div>
        </div>

        <div v-for="(items, itemType, typeInBlockIndex) in visibleItems"
             :key="blockId + itemType"
             :class="{'error': errorItems.indexOf(itemType) > -1}">


            <hr class="cart__sep" v-if="itemTypes[itemType] && ((blockLogo === '' && typeInBlockIndex === 0) || typeInBlockIndex > 0)">
            <div
                v-if="itemTypes[itemType]"
                class="bold t-left mb-2"
            >
                {{ itemTypes[itemType] }}
            </div>
            <div v-else-if="itemType !== 'tariff_mango_mobile' && !itemTypes[itemType] && itemType !== 'competitor_analysis'"
                 class="cart__row">
                <div class="cart__name">Общая информация</div>
            </div>

            <div v-for="(cartItem, itemId, index) in items" :key="'item_' + itemId">
                <div class="cart__row">
                    <div class="cart__grow">
                        <!--        todo изменить логику на то, как ниже при добавление красивого номер добавить ключ с CODE красивого номера-->
                        <div v-if="itemType === 'number' || itemType === 'number_fmc' || itemType === 'number_mvno'"
                             :data-element="'cart_title_' + itemType + '_beauty_' + cartItem.BEAUTY_TYPE + '_' + blockIndex + '_' + index"
                             v-bind:class="{
                    'error': errorItems.indexOf(itemId) > -1,
                    'cart__num': cartItem.BEAUTY_TYPE === 0,
                    'cart__num cart__num--special cart__num--silver': cartItem.BEAUTY_TYPE === 1,
                    'cart__num cart__num--special cart__num--gold': cartItem.BEAUTY_TYPE === 2,
                    'cart__num cart__num--special cart__num--platinum': cartItem.BEAUTY_TYPE === 3,
                     }">
                            {{ cartItem.TITLE }}
                        </div>
                        <div
                            v-else-if="itemType !== 'tariff_mango_mobile' && itemType !== 'competitor_analysis'"
                            :data-element="'cart_title_' + itemType + '_main'"
                        >
                          {{  cartItem.TITLE }}
                        </div>

                        <template v-if="cartItem.DISCOUNT_PRICE !== 0 && cartItem.CATALOG_XML_ID === 'number'">
                            <br>
                            <div class="cart__mt--xs cart__note cart__note--tooltip">
                                Акция в рамках рекламной компании
                                <!--            todo раскомментировать при появления описания акции, если такой функционал будет-->
                                <!--                <span class="cart__tooltip">-->
                                <!--                  Информация об ошибке.-->
                                <!--                  Короткий объясняющий текст-->
                                <!--                </span>-->
                            </div>
                        </template>

                        <template v-if="cartItem.CAN_DELETE && (cartItem.CATALOG_XML_ID === 'number' || cartItem.CATALOG_XML_ID === 'number_mvno')">
                            <br>
                            <button
                                class="cart__del cart__mt--sm"
                                :data-tooltip="typeProps(itemType).removeTooltip"
                                :data-element="'cart_remove_' + itemType + '_' + blockIndex + '_' + index"
                                @click="removeItem(itemId)">Удалить
                            </button>
                        </template>
                    </div>

                    <div class="cart__right"
                         v-bind:class="{'error': errorItems.indexOf(itemId) > -1}">
                        <template v-if="cartItem.DISCOUNT_PRICE !== 0 && cartItem.PRICE_ONCE !== 0 && cartItem.PRICE_FULL !== 0">
                            <div class="cart__price">
                                <span class="cart__val cart__val--red">{{ formatPrice(cartItem.PRICE) }}</span>
                                <span class="cart__units cart__units--red"> руб.</span>
                            </div>
                            <div class="cart__price cart__price--strike">
                                <span class="cart__val"> {{ formatPrice(cartItem.PRICE_ONCE) }}</span>
                                <span class="cart__units"> руб.</span>
                            </div>
                        </template>

                        <div v-if="cartItem.DISCOUNT_PRICE === 0 && (cartItem.PRICE_ONCE !== 0 && cartItem.PRICE_ONCE !== '') && cartItem.PRICE_FULL !== 0 && cartItem.CATALOG_XML_ID !== 'competitor_analysis'"
                             class="cart__price">
                            <span :data-element="'cart_price_once_' + itemType + '_' + blockIndex + '_' + index">
                                {{ formatPrice(cartItem.PRICE_ONCE * cartItem.QUANTITY) }}</span>
                            <span class="cart__units"> руб.</span>
                        </div>

                        <div v-if="cartItem.PRICE_MONTHLY !== '' && cartItem.PRICE_MONTHLY !== 0"
                             class="cart__price cart__mt--xs">
                            <span :data-element="'cart_price_monthly_' + itemType + '_' + blockIndex + '_' + index">
                                {{ formatPrice(cartItem.PRICE_MONTHLY * cartItem.QUANTITY) }}
                            </span>
                            <span class="cart__units">&nbsp;руб./мес.</span>
                        </div>
                    </div>
                </div>

                <!-- ВАТС Минимальный гарантированный платеж -->
                <div v-if="cartItem.hasOwnProperty('CURRENT_TARIFF') && (!cartItem.hasOwnProperty('IS_MKCH') || !cartItem.IS_MKCH)"
                     class="cart__row">
                    <div @click="$emit('openModal', 'mgp', cartItem)"
                         class="cart__grow">
                        <span :data-element="'cart_title_' + itemType + '_mgp_' + blockIndex + '_' + index"
                              class="cart__trigger">Минимальный гарантированный платеж</span>
                    </div>

                    <div class="cart__right">
                        <div v-if="!cartItem.BUY_ON_EXIST_VATS"
                             class="cart__price">
                            <span :data-element="'cart_price_monthly' + itemType + '_mgp_' + blockIndex + '_' + index"
                                  class="cart__val">{{ formatPrice(cartItem.PRICE_MGP) }} </span>
                            <span class="cart__units">руб./мес.</span>
                        </div>
                    </div>
                </div>

                <!-- ВАТС Дополнительные профили сотрудников -->
                <div v-if="cartItem.hasOwnProperty('PROFILES') && !cartItem.IS_DEMO_VATS"
                     class="cart__row cart__row--with-quantity">
                    <div class="cart__grow"
                         @click="$emit('openModal', 'profiles', cartItem)">
                  <span :data-element="'cart_title_' + itemType + '_profiles_' + blockIndex + '_' + index"
                        class="cart__trigger">{{ cartItem.PROFILES.TITLE }}
                  </span>
                    </div>
                    <div>
                        <div class="quant quant--sm">
                            <button
                                :disabled="cartItem.PROFILES.QUANTITY + quantityProfilesDefaultFree <= quantityProfilesDefaultFree"
                                :data-element="'cart_dec_profiles_quantity_' + itemType + '_' + blockIndex"
                                @click="setProfilesQuantity(itemId, parseInt(cartItem.PROFILES.QUANTITY) - 1)"
                                class="button button--md button--tonal quant__button quant__button--sm"
                                :class="{'button--disabled': cartItem.PROFILES.QUANTITY + quantityProfilesDefaultFree <= quantityProfilesDefaultFree}">
                                <i class="ui ui-minus"></i>
                            </button>
                            <div class="input quant__input">
                                <input
                                    class="input__field input__field--compact input__field--md quant__field quant__field--sm"
                                    type="text"
                                    maxlength="3"
                                    data-min="0"
                                    :data-element="'cart_profiles_quantity_input_' + itemType + '_' + blockIndex"
                                    :data-limit="9999"
                                    @input="setProfilesQuantity(itemId, profilesQuantityValueManualInputCorrection(parseInt($event.target.value)))"
                                    :value="cartItem.PROFILES.QUANTITY + quantityProfilesDefaultFree">
                            </div>
                            <button :disabled="cartItem.PROFILES.QUANTITY >= 9999"
                                    :data-element="'cart_inc_profiles_quantity_' + itemType + '_' + blockIndex"
                                    @click="setProfilesQuantity(itemId, parseInt(cartItem.PROFILES.QUANTITY) + 1)"
                                    class="button button--md button--tonal quant__button quant__button--sm">
                                <i class="ui ui-plus"></i>
                            </button>
                        </div>
                    </div>
                    <div class="cart__right">
                        <div class="cart__price"
                             :class="{'text-orange': cartItem.PROFILES.QUANTITY > 0 && cartItem.PROFILES.PRICE_MONTHLY !== cartItem.PROFILES.PRICE_MONTHLY_FULL}">
                            <s v-if="cartItem.PROFILES.QUANTITY > 0 && cartItem.PROFILES.PRICE_MONTHLY !== cartItem.PROFILES.PRICE_MONTHLY_FULL"
                               :data-element="'cart_action_price_monthly_' + itemType + '_profiles_' + blockIndex + '_' + index"
                               class="text-grey fs-sm mr-1">
                                {{ cartItem.PROFILES.PRICE_MONTHLY_FULL * cartItem.PROFILES.QUANTITY }}
                            </s>
                            <span
                                :data-element="'cart_price_monthly_' + itemType + '_profiles_' + blockIndex + '_' + index"
                                class="cart__val">
                      {{ formatPrice(cartItem.PROFILES.PRICE_MONTHLY * cartItem.PROFILES.QUANTITY) }}
                    </span>
                            <span class="cart__units"> руб./мес.</span>
                        </div>
                    </div>
                </div>

                <!-- МангоМобайл Тариф Раскомментировать, когда появится текст модалки -->
                <div v-if="cartItem.hasOwnProperty('TARIFF_MANGO_MOBILE') && !needAddTariffMvno"
                     class="cart__row">
<!--                  <div @click="$emit('openModal', 'tariff_mango_mobile', cartItem.TARIFF_MANGO_MOBILE.TITLE)"-->
<!--                       class="cart__grow">-->
<!--                              <span :data-element="'cart_title_' + itemType + '_tariff_mango_mobile_' + blockIndex + '_' + index"-->
<!--                                    class="cart__trigger">Тариф "{{ cartItem.TARIFF_MANGO_MOBILE.TITLE }}"</span>-->
<!--                  </div>-->
                  <!-- МангоМобайл Тариф Закомментировать, когда появится текст модалки -->
                  <div class="cart__grow">
                              <span :data-element="'cart_title_' + itemType + '_tariff_mango_mobile_' + blockIndex + '_' + index">
                                Тариф "{{ cartItem.TARIFF_MANGO_MOBILE.TITLE }}"
                              </span>
                  </div>
                </div>


                <!-- КТ Плата за показы  -->
                <div v-if="cartItem.hasOwnProperty('ABON_MIN_HITS')"
                     class="cart__row">
                    <div @click="$emit('openModal', itemType, cartItem)"
                         class="cart__grow">
                        <span :data-element="'cart_title_' + itemType + '_abon'"
                              class="cart__trigger">{{ cartItem.ABON_MIN_HITS.TITLE }}</span>
                    </div>

                    <div class="cart__right">
                        <div class="cart__price">
                            <s v-if="cartItem.ABON_MIN_HITS.PRICE_MONTHLY_FULL > cartItem.ABON_MIN_HITS.PRICE_MONTHLY"
                               class="cart__val"
                               :data-element="'cart_action_price_monthly_' + itemType + '_abon_' + blockIndex + '_' + index">
                                {{ formatPrice(cartItem.ABON_MIN_HITS.PRICE_MONTHLY_FULL) }}
                            </s>
                            <span :data-element="'cart_price_monthly_' + itemType + '_abon_' + blockIndex + '_' + index"
                                  class="cart__val">
                      {{ formatPrice(cartItem.ABON_MIN_HITS.PRICE_MONTHLY) }}
                    </span>
                            <span class="cart__units">руб./мес.</span>
                        </div>
                    </div>
                </div>

                <!-- Дополнения -->
                <div v-if="typeInBlockIndex === 0">
                    <div v-for="(subItem, subItemId) in subItems"
                         :key="'sub_item_'+subItemId"
                         class="cart__row">
                        <div class="cart__grow">
                            <span v-if="subItem.CATALOG_XML_ID === 'number' || subItem.CATALOG_XML_ID === 'cov'"
                                  :data-element="'cart_title_' + itemType + '_' + subItem.CATALOG_XML_ID + '_subitem'">
                                {{ subItem.TITLE }}
                            </span>
                            <span v-else
                                  :data-element="'cart_title_' + itemType + '_' + subItem.CATALOG_XML_ID + '_subitem'"
                                  @click="$emit('openModal', itemType, subItem)"
                                  class="cart__trigger">{{ subItem.TITLE }}
                            </span>
                        </div>


                        <div class="cart__right">
                            <div  v-if="subItem.PRICE_ONCE > 0"
                                  class="cart__price">
                                <span :data-element="'cart_price_once_' + itemType + '_subitem_' + blockIndex + '_' + index"
                                      class="cart__val">
                                    {{ formatPrice(subItem.PRICE_ONCE) }}
                                </span>
                                <span class="cart__units">руб.</span>
                            </div>
                            <div v-if="subItem.PRICE_MONTHLY_FULL > 0"
                                 class="cart__price cart__mt--xs">
                                <span :data-element="'cart_price_monthly_' + itemType + '_subitem_' + blockIndex + '_' + index"
                                      class="cart__val">
                                    {{ formatPrice(subItem.PRICE_MONTHLY_FULL) }}
                                </span>
                                <span class="cart__units">руб./мес.</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="cartItem.hasOwnProperty('IS_AGENCY') && cartItem.IS_AGENCY"
                     class="container t-left mb-2">
                    <small class="color-grey"
                           :data-element="'cart_is_agency_note_' + itemType + '_' + blockIndex + '_' + index">*
                        Оплата за номер производится провайдеру "{{
                            cartItem.PROVIDER
                        }}"</small>
                </div>

                <div v-if="itemType === 'ported_number'" class="container t-left mb-2">
                    <small class="color-grey"
                           :data-element="'cart_ported_number_note_' + itemType + '_' + blockIndex + '_' + index">Абонентская
                        плата за номера оплачивается Вашему текущему
                        оператору</small>
                </div>

                <div v-if="cartItem.hasOwnProperty('EXTERNAL') && cartItem.EXTERNAL === 'Y'"
                     class="container t-left mb-2">
                    <small class="color-grey"
                           :data-element="'cart_ported_external_' + itemType + '_' + blockIndex + '_' + index">Номер
                        бронируется у внешнего провайдера</small>
                </div>

                <!-- "Удалить"-->
                <div v-if="isShowDelBtn(cartItem) || cartItem.CAN_DELETE && (cartItem.CATALOG_XML_ID !== 'number' && cartItem.CATALOG_XML_ID !== 'number_mvno' && cartItem.CATALOG_XML_ID !== 'tariff_mango_mobile') && !isCompetitorAnalysisBlock"
                     class="cart__row">
                    <button class="cart__del"
                            :data-tooltip="typeProps(itemType).removeTooltip"
                            :data-element="'cart_remove_' + itemType + '_' + blockIndex + '_' + index"
                            @click="removeItem(itemId)">Удалить
                    </button>
                </div>

                <!-- Выбрать номер, если в корзине еще нет номеров-->
                <div v-if="itemType === 'vats' && !cartItem.BUY_ON_EXIST_VATS && (!cartItem.hasOwnProperty('NUMBERS') || cartItem.NUMBERS.length === 0)"
                     class="cart__row">
                    <div class="cart__grow">
                        <a :href="needAddNumbersMvno ? '/shop/mvno/' + (blockId !== 'withoutParent' ? '?productId=basket_' + blockId : '') : '/shop/numbers/' + (blockId !== 'withoutParent' ? '?productId=basket_' + blockId : '')"
                           :data-element="'cart_select_number_' + itemType + '_' + blockIndex"
                           class="button button--sm button--outline"
                        >
                            Выбрать номера
                        </a>
                    </div>
                </div>
            </div>

            <div v-if="itemType === 'number' && (blockId === 'withoutParent' || cartItems[blockId].PROPS.CHAIN.VALUE !== 'virtual_number')"
                 class="cart__row">
                <div class="cart__grow">
                    <a :data-element="'cart_select_more_numbers_' + itemType + '_' + blockIndex"
                       :href="getNumbersUrl(blockId)"
                       class="button button--sm button--outline">
                        Выбрать еще номера</a>
                </div>
            </div>

            <div v-if="itemType === 'number_fmc'"
                 class="cart__row">
                <div class="cart__grow">
                    <a :data-element="'cart_select_more_fmc_' + itemType + '_' + blockIndex"
                       :href="'/shop/fmc/' + (blockId !== 'withoutParent' ? '?productId=basket_' + blockId : '')"
                       class="button button--sm button--outline">
                        Выбрать еще номера</a>
                </div>
            </div>

            <div v-if="itemType === 'number_mvno'"
                 class="cart__row">
              <div class="cart__grow">
                <a
                    :data-element="'cart_select_more_mvno_' + itemType + '_' + blockIndex"
                    :href="'/shop/mvno/' + (blockId !== 'withoutParent' ? '?productId=basket_' + blockId : '')"
                    class="button button--sm button--outline"
                >
                  Выбрать еще номера
                </a>
              </div>
            </div>
        </div>

        <!-- "Добавьте красивый номер" -->
        <div v-for="(items, itemType) in visibleItems"
             :key="'numbers_upsale_' + blockId + itemType">
            <template v-if="itemType === 'vats' && numbersForUpsale.length > 0">

                <hr class="cart__sep">

                <div class="cart__row">
                    <div class="cart__name">
                        Добавьте красивый номер:
                    </div>
                </div>

                <div class="cart__scroll">
                    <div class="cart__items">
                        <div v-for="(number, numberKey) in numbersForUpsale"
                             :key="blockId + 'upsaleNumber' + numberKey"
                             class="cart__item">
                            <div class="cart__card">
                                <div>
                                    <div class="cart__num cart__name cart__num--special cart__num"
                                         :class="'cart__num--' + number.BEAUTY_CODE">{{ number.FORMATTED_NAME }}
                                    </div>
                                </div>
                                <div class="cart__grow">
                                    <div class="cart__mt--sm">
                                        Подключение
                                        <span class="cart__price">
                    <span class="cart__val">{{ formatPrice(number.PRICE_ONCE) }}</span>
                    <span class="cart__units"> руб.</span>
                  </span>
                                    </div>
                                    <div class="cart__mt--xs">
                                        Ежемесячная плата
                                        <span class="cart__price">
                    <span class="cart__val">{{ formatPrice(number.PRICE_MONTHLY) }}</span>
                    <span class="cart__units"> руб.</span>
                  </span>
                                    </div>
                                </div>
                                <div>
                                    <button class="cart__mt--md button button--sm btn green brd sm mt-2"
                                            :class="{'btn--wait': loader.numbersUpsale}"
                                            :disabled="loader.numbersUpsale"
                                            :data-element="'cart_add_number_' + itemType + '_' + blockIndex"
                                            @click="addNumberToCart(number.ID, blockId, number.TARIFF_ID)">Добавить
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <CartUpsellService
            v-if="showServiceUpsale && servicesForUpsale"
            :items="servicesForUpsale"
            :dataElement="'upsale_service_' + blockIndex"
            :parent-cart-id="blockId"
            :loader="loader"
            @addServiceToCart="addServiceToCart"
            @removeItemNoModal="removeItemNoModal"
            @openModal="openModal"
        />
        <CartUpsellService
            v-if="showServiceUpsale && productsForUpsale"
            :items="productsForUpsale"
            :dataElement="'upsale_product_' + blockIndex"
            :parent-cart-id="blockId"
            :loader="loader"
            :isUpsaleProduct="true"
            @addProductToCart="addProductToCart"
            @removeItemNoModal="removeItemNoModal"
            @openModal="openModal"
        />
    </div>
</template>

<script>
import CartUpsellService from './CartUpsellService.vue';
import priceFormatter from '../../../../lib/priceFormatter.js'

/* eslint-disable no-prototype-builtins */
export default {
    name: 'CartBlock',
    components: {
        CartUpsellService
    },
    props: {
        blockId: {
            type: String
        },
        blockIndex: {
            type: Number
        },
        blockLogo: {
            type: String
        },
        blockTitle: {
            type: String
        },
        blockItems: {
            type: Object
        },
        cartItems: {
            type: Object
        },
        cartDiscount: {
            type: Object
        },
        itemTypes: {
            type: Object
        },
        loader: {
            type: Object
        },
        showBlockTotal: {
            type: Boolean
        },
        showServiceUpsale: {
            type: Boolean
        },
        servicesForUpsale: {
            type: Array
        },
        productsForUpsale: {
            type: Array
        },
        numbersForUpsale: {
            type: Array
        },
        errorItems: {
            type: Array
        },
        busyNumbers: {
            type: Array
        },
        blockTotalPrice: {
            type: Number
        },
        needAddTariffMvno: {
          type: Boolean
        },
        needAddNumbersMvno: {
          type: Boolean
        },
        isCompetitorAnalysisBlock: {
          type: Boolean,
          default: false,
        },
        isCompetitorAnalysisNewVats: {
            type: Boolean,
            default: false,
        },
        isMDGBlock: { // Манго Диалоги
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            logoViewBox: {
                hpbx: '0 0 168 28',
                cov: '0 0 281 56',
                dct: '0 0 127 28',
                mkch: '0 0 141 32',
                mdg: '0 0 141 32',
                mvno: '0 0 199 33',
                ca: '0 0 245 32'
            },
            quantityProfilesDefaultFree: 3
        };
    },
    methods: {
        isShowDelBtn: function (cartItem) {
          return (
              (
                  cartItem.CATALOG_XML_ID === 'competitor_analysis'
                  && this.isCompetitorAnalysisNewVats
              )
              ||
              (
                  cartItem.CATALOG_XML_ID === 'vats'
                  && this.isCompetitorAnalysisBlock
                  && !this.isCompetitorAnalysisNewVats
              )
          );
        },
        formatPrice: function (price) {
            return priceFormatter.format(price)
        },
        removeItem: function (itemId) {
            let t = this;
            t.$emit('removeItem', itemId, t.blockId);
        },
        removeItemNoModal: function (itemId) {
            let t = this;
            t.$emit('removeItemNoModal', itemId, t.blockId);
        },
        changeQuantity: function (itemId, quantity) {
            let t = this;
            t.$emit('changeQuantity', itemId, quantity, t.blockId);
        },
        setQuantity: function (itemId, quantity) {
            let t = this;
            quantity = quantity > 0 ? quantity : 1;
            t.cartItems[itemId]['QUANTITY'] = quantity;
            t.$emit('changeQuantity', itemId, quantity, t.blockId);
        },
        setProfilesQuantity: function (parentItemId, quantity) {
            var t = this;
            quantity = quantity > 0 ? quantity : 0;

            if (t.cartItems[parentItemId]['PROFILES'].hasOwnProperty('CART_ITEM')) {
                t.cartItems[t.cartItems[parentItemId]['PROFILES']['CART_ITEM']['ID']]['QUANTITY'] = quantity;
            }
            t.$emit('setProfilesQuantity', parentItemId, quantity);
        },
        // Корректировка значения при ручном вводе
        profilesQuantityValueManualInputCorrection: function (quantity) {
            let t = this;

            if (quantity < t.quantityProfilesDefaultFree) {
                return 0;
            }

            if (quantity > t.quantityProfilesDefaultFree) {
                quantity -= t.quantityProfilesDefaultFree;
            }

            return quantity;
        },
        addNumberToCart: function (numberId, parentId, tariffId) {
            var t = this;
            t.$emit('addNumberToCart', numberId, parentId, tariffId);
        },
        cartTotalDiscountFull: function () {
            var t = this;
            let sumTotalDiscount = 0;

            for (let itemId in t.cartItems) {
                if (t.cartItems[itemId].CART_BLOCK_ID === t.blockId) {
                    sumTotalDiscount += t.cartItems[itemId].SUM_DISCOUNT_PRICE
                }

            }
            return sumTotalDiscount;
        },
        typeProps: function (itemType) {
            let props = {
                'class': null,
                'titleClass': null,
                'removeTooltip': null,
            };
            switch (itemType) {
                case 'vats':
                    props.removeTooltip = 'ВАТС удаляется сразу вместе с профилями, услугами и номерами';
                    props.titleClass = 'fs-lg';
                    break;

                case 'cov':
                case 'cov_product':
                case 'dkt':
                case 'mkch':
                    props.titleClass = 'fs-lg';
                    break;

                case 'number':
                case 'number_fmc':
                case 'ported_number':
                case 'service':
                    break;
            }

            return props;
        },
        addServiceToCart: function (serviceOfferId, parentId, quantity) {
            this.$emit('addServiceToCart', serviceOfferId, parentId, quantity);
        },
        addProductToCart: function (addToCartAction, productId, blockId) {
            this.$emit('addProductToCart', addToCartAction, productId, blockId);
        },
        openModal: function (typeModal, item) {
            this.$emit('openModal', typeModal, item);
        },
        addLike: function (cartItemId, productId) {
            this.$emit('addLike', cartItemId, productId);
        },
        getNumbersUrl: function (blockId) {
            let url = '/shop/numbers/';

            if (this.cartItems[blockId]?.PROPS?.CHAIN?.VALUE === 'numbers_mobile') {
                url = '/shop/numbers_mobile/';
            }

            return url + (blockId !== 'withoutParent' ? '?productId=basket_' + blockId : '');
        }
    },
    computed: {
        visibleItems: function () {
            let t = this;
            let blockItems = {};
            for (let itemType in t.blockItems) {

                t.blockItems[itemType].forEach(function (itemId) {
                    if (!t.cartItems.hasOwnProperty(itemId)) {
                        return;
                    }

                    let item = t.cartItems[itemId];
                    //Проверка "услуги" на наличие в корзине и скрытие самого блока.
                    for (let service in t.servicesForUpsale) {
                        if (t.servicesForUpsale[service].OFFER_ID === item.PRODUCT_ID) {
                            item.HIDE_IN_CART = true
                            t.servicesForUpsale[service].IN_CART = true;
                            t.servicesForUpsale[service].IN_CART_ID = item.ID;
                        }
                    }

                    //Проверка "продукта в *продукте" на наличие в корзине и скрытие самого блока.
                    for (let product in t.productsForUpsale) {
                        if (t.productsForUpsale[product].ID === item.PRODUCT_ID) {
                            item.HIDE_IN_CART = true

                            t.productsForUpsale[product].IN_CART = true;
                            t.productsForUpsale[product].IN_CART_ID = item.ID;
                        }
                    }

                    if (!item.hasOwnProperty('HIDE_IN_CART') || !item.HIDE_IN_CART) {
                        if (!blockItems.hasOwnProperty(itemType)) {
                            blockItems[itemType] = {};
                        }
                        blockItems[itemType][itemId] = item;
                    }
                });
            }

            return blockItems;
        },
        subItems: function () {
            let t = this;
            let subItems = {};
            for (let itemType in t.blockItems) {
                t.blockItems[itemType].forEach(function (itemId) {
                    if (!t.cartItems.hasOwnProperty(itemId)) {
                        return;
                    }

                    let item = t.cartItems[itemId];
                    if (item.hasOwnProperty('HIDE_IN_CART') && item.HIDE_IN_CART &&
                        item.hasOwnProperty('SHOW_AS_SUB_ITEM') && item.SHOW_AS_SUB_ITEM) {
                        if (item.hasOwnProperty('PRICE_MGP')) {
                            item.PRICE_MONTHLY += item.PRICE_MGP;
                            item.PRICE_MONTHLY_FULL += item.PRICE_MGP;
                            item.PRICE_MGP = 0;
                        }
                        subItems[itemId] = item;
                    }
                });
            }

            return subItems;
        }
    },
}
</script>

<style lang="scss">
@import '../../../../scss/transition/slide-fade';
@import "../../../../../../static_files_new/scss/components-shop/shop-cart-upsale.scss";
</style>